var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-sort"},[_c('label',{staticClass:"product-sort__label",domProps:{"innerHTML":_vm._s(_vm.sortLabel)}}),_c('div',{staticClass:"product-sort__tags"},_vm._l((_vm.tags),function(tag){return _c('button',{staticClass:"product-sort__tag",class:[
        _vm.sortOut.includes(tag) ? 'active' : '',
        _vm.sortOut.length > 1 && tag === 'view all' ? 'inactive' : ''],on:{"click":function($event){_vm.selectTag(tag)}}},[_vm._v(_vm._s(tag))])}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057b326e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/ProductSort.vue
// module id = null
// module chunks = 